import API_URL from "helpers/apiURL";
import fetch from "isomorphic-fetch";

export async function verifyAvailability(date, hour, advisorId, workerId, brandId, workshopId) {
  const advisor = advisorId ? '&advisor_id='+advisorId : '&worker_id='+workerId;
  const availability = await fetch(
    `${API_URL}/verify-availability?date=${date}&hour=${hour}&brand_id=${brandId}&workshop_id=${workshopId}${advisor}`,
    {
      method: "GET",
    }
  )
    .then((response) => response.json())
    .catch(() => dispatch(shiftFailed()));

  return availability?.data?.available ?? false;
}
